module.exports = __webpack_public_path__ + "img/sb4.34b4b55e.gif";